if (!customElements.get('waha-ingredient-carousel')) {
  customElements.define('waha-ingredient-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ingredient-track]');
      this.cards = [...this.querySelectorAll('[data-ingredient-card]')];
      if (!this.track || !this.cards.length) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous = this.querySelector('[data-ingredient-prev]');
      this.next = this.querySelector('[data-ingredient-next]');
      this.dots = [...this.querySelectorAll('[data-ingredient-dot]')];
      this.status = this.querySelector('[data-ingredient-status]');
      this.previous.addEventListener('click', () => this.go(this.current - 1), options);
      this.next.addEventListener('click', () => this.go(this.current + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const moves = { ArrowLeft: this.current - 1, ArrowRight: this.current + 1, Home: 0, End: this.last };
        if (event.key in moves) { event.preventDefault(); this.go(moves[event.key]); }
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.querySelector('[data-ingredient-controls]').dataset.ready = '';
      this.update();
    }
    position(card) {
      return card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
    }
    go(index) {
      index = Math.max(0, Math.min(this.last, index));
      this.track.scrollTo({ left: this.position(this.cards[index]) - 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const width = this.cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = width + gap;
      this.last = Math.min(this.cards.length - 1, Math.ceil(Math.max(0, maxScroll - 3) / step));
      this.current = Math.min(this.last, Math.round(Math.max(0, this.track.scrollLeft) / step));
      this.previous.disabled = this.track.scrollLeft <= 3;
      this.next.disabled = this.track.scrollLeft >= maxScroll - 3;
      this.dots.forEach((dot, index) => {
        dot.hidden = index > this.last;
        dot.setAttribute('aria-current', index === this.current ? 'true' : 'false');
      });
      this.status.textContent = `${this.current + 1} / ${this.cards.length}`;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
